<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: backUrl, text: 'said_events_title' },
                     { url: currentUrl, text: 'said_events_addTitle' }
                     ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'said_events_addTitle' | translate}}</h1>
    </header>

    <app-alert level="info" *ngIf="pointsInfoHtml" [innerHTML]="pointsInfoHtml | safeHtml"></app-alert>

    <section class="block">
        <div class="row">
            <div class="form-field col-md-4">
                <label class="form-label">{{'said_events_FilterAll' | translate}}</label>
                <input class="form-control" autofocus [(ngModel)]="currentFilter.All" name="currentFilter.All">
            </div>

            <div class="form-field col-md-4">
                <label class="form-label">{{'said_events_FilterEventType' | translate}}</label>
                <app-select [(ngModel)]="currentFilter.EventType"
                            name="currentFilter.EventType"
                            #eventType
                            [options]="FilterEventType"
                            [displayProperty]="'Value'"
                            (selectionChange)="reloadEventTypeFilter()">
                </app-select>
            </div>
            <div class="form-field col-md-4">
                <label class="form-label">{{'said_events_FilterEventAddedType' | translate}}</label>
                <app-select [(ngModel)]="currentFilter.EventAdded"
                            [options]="FilterEventAddedType"
                            name="currentFilter.EventAdded" #eventType>
                </app-select>
            </div>
        </div>

        <ng-container *ngIf="extendedFilter">
            <div class="row">
                <div class="form-field col-md-4">
                    <label class="form-label">{{'said_events_FilterDateFrom' | translate}}</label>
                    <app-date [(ngModel)]="currentFilter.DateFrom" name="currentFilter.DateFrom"></app-date>
                </div>

                <div class="form-field col-md-4">
                    <label class="form-label">{{'said_events_FilterDateTo' | translate}}</label>
                    <app-date [(ngModel)]="currentFilter.DateTo" name="currentFilter.DateTo"></app-date>
                </div>
            </div>

            <div class="row">
                <div class="form-field col-md-4">
                    <label class="form-label">{{'said_events_filter_lblForTimepickerFrom' | translate}}</label>

                    <div class="d-flex">
                        <div>
                            <app-select [(ngModel)]="currentFilter.TimeFromHours"
                                        name="currentFilter.TimeFromHours"
                                        [options]="hourOptions"></app-select>
                        </div>

                        <div class="ms-1">
                            <app-select [(ngModel)]="currentFilter.TimeFromMinutes"
                                        name="currentFilter.TimeFromMinutes"
                                        [options]="minuteOptions"></app-select>
                        </div>
                    </div>
                </div>

                <div class="form-field col-md-4">
                    <label class="form-label">{{'said_events_filter_lblForTimepickerTo' | translate}}</label>

                    <div class="d-flex">
                        <div>
                            <app-select [(ngModel)]="currentFilter.TimeToHours"
                                        name="currentFilter.TimeToHours"
                                        [options]="hourOptions"></app-select>
                        </div>

                        <div class="ms-1">
                            <app-select [(ngModel)]="currentFilter.TimeToMinutes"
                                        name="currentFilter.TimeToMinutes"
                                        [options]="minuteOptions"></app-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-field col-md-8">
                    <label class="form-label">{{'said_events_FilterAddress' | translate}}</label>
                    <input class="form-control" [(ngModel)]="currentFilter.Address" name="currentFilter.Address">
                </div>

                <div class="form-field col-md-4">
                    <label class="form-label">{{'said_events_FilterSkillCategory' | translate}}</label>
                    <app-select [(ngModel)]="currentFilter.SkillCategory" name="currentFilter.SkillCategory"
                                [options]="FilterSkillCategory">
                    </app-select>
                </div>
            </div>
        </ng-container>

        <div class="mb-3">
            <button type="button" class="btn btn-outline" (click)="extendedFilter = !extendedFilter">
                <i [class]="extendedFilter ? 'fi fi-rs-angle-up' : 'fi fi-rs-angle-down'"></i>
                {{'said_events_extended_filter' | translate}}
            </button>

            <button type="button" class="btn btn-outline" (click)="ClearFilter()">
                <i class="fi fi-rs-cross"></i>
                {{'said_events_clear_filter' | translate}}
            </button>
        </div>
    </section>

    <ng-container *ngIf="isLoaded">
        <app-alert level="warning" *ngIf="!events.length">
            {{'said_events_noProgramCanBeAdded' | translate}}
        </app-alert>

        <app-alert level="warning" *ngIf="events.length && !filteredEvents.length">
            {{'said_events_noProgramFound' | translate}}
        </app-alert>

        <app-said-event-card *ngFor="let c of filteredEvents" [data]="c" [studentId]="Student_guid"></app-said-event-card>
    </ng-container>

    <div class="form-actions">
        <button type="button" class="btn btn-primary" [routerLink]="backUrl | localize">
            {{'said_events_finish' | translate}}
        </button>
    </div>
</div>
